/** Ordine di lettura coerente per anagrafiche e relativi selettori. */
export function orderMastersByName<T>(table: string, rows: T[]): T[] {
  if (!['foods', 'recipes', 'suppliers', 'storage_units'].includes(table)) return rows;
  const name = (row: T): string => String((row as { name?: string }).name ?? '');
  return [...rows].sort((left, right) =>
    name(left).localeCompare(name(right), 'it', { sensitivity: 'base', numeric: true }));
}
